/* ==========================================================================
   Tribe & Trowel — front-end interactivity (Estate / Horizon homepage)
   Ported from the Claude Design prototype runtime, adapted for the real store:
   primary CTAs ([data-tt-buy]) add the 33-Pack variant to the live cart.
   Vanilla JS, self-initializing. No framework required.
   ========================================================================== */
(function () {
  "use strict";

  /* -------------------------------------------------- *
   * Data: 33-variety zone matrix + crop families       *
   * -------------------------------------------------- */
  // Each entry: [name, 13-char string] where char[zone-1] is
  // 'y' thrives · 'm' grows with effort · 'n' not suited.
  var VARIETIES = [
    ["Kentucky Wonder Pole Bean", "mmyyyyyyyyyyy"],
    ["Sugar Daddy Pea", "yyyyyyyymmmmm"],
    ["Calabrese Broccoli", "mmyyyyyyyyyyy"],
    ["Waltham 29 Broccoli", "mmyyyyyyyyyyy"],
    ["Long Island Brussels Sprouts", "nmyyyyyyyyyyy"],
    ["Early Jersey Wakefield Cabbage", "myyyyyyyyyyyy"],
    ["Golden Acre Cabbage", "myyyyyyyyyyyy"],
    ["Snowball Cauliflower", "nmyyyyyyyyyyy"],
    ["Vates Collard", "nmyyyyyyyyyyy"],
    ["Dwarf Blue Curled Kale", "yyyyyyyyyyyyy"],
    ["Purple Vienna Kohlrabi", "myyyyyyyyyyyy"],
    ["American Purple Top Rutabaga", "yyyyyyyymmmnn"],
    ["Purple Top Turnip", "yyyyyyyyyyyyy"],
    ["Golden Ball Turnip", "yyyyyyyyyyyyy"],
    ["Seven Top Turnip", "yyyyyyyyyyyyy"],
    ["Detroit Dark Red Beet", "yyyyyyyyyyyyy"],
    ["Scarlet Nantes Carrot", "yyyyyyyyyyyyy"],
    ["Chantenay Carrot", "yyyyyyyyyyyyy"],
    ["Harris Early Parsnip", "myyyyyyymmnnn"],
    ["Cherry Belle Radish", "yyyyyyyyyyyyy"],
    ["Tokyo Bunching Onion", "myyyyyyyyyyyy"],
    ["Marketmore 76 Cucumber", "nnmyyyyyyyyyy"],
    ["Black Beauty Squash", "nnmyyyyyyyyyy"],
    ["Waltham Butternut Squash", "nnnmyyyyyyyyy"],
    ["California Wonder Pepper", "nnmmyyyyyyyyy"],
    ["Large Red Cherry Tomato", "nnmyyyyyyyyyy"],
    ["Grand Rapids Lettuce", "yyyyyyyyyyyyy"],
    ["Black Seeded Simpson Lettuce", "yyyyyyyyyyyyy"],
    ["Butterhead Lettuce", "yyyyyyyyyyyyy"],
    ["Ruby Red Leaf Lettuce", "yyyyyyyyyyyyy"],
    ["Utah Tall Celery", "nnyyyyyyyyyyy"],
    ["Bloomsdale Spinach", "myyyyyyyymmmm"],
    ["Fordhook Giant Swiss Chard", "myyyyyyyyyyyy"]
  ];

  var FAMILIES = [
    { label: "Brassicas", sub: "cabbage-family workhorses", count: 13, c: "#1E4D32", t: "#E7EEE9",
      blurb: "The backbone of a year-round plate — cold-hardy, heavy-yielding, and endlessly versatile from spring slaws to deep-winter braises.",
      items: ["Calabrese Broccoli", "Waltham 29 Broccoli", "Long Island Brussels Sprouts", "Early Jersey Wakefield Cabbage", "Golden Acre Cabbage", "Snowball Cauliflower", "Vates Collard", "Dwarf Blue Curled Kale", "Purple Vienna Kohlrabi", "American Purple Top Rutabaga", "Purple Top Turnip", "Golden Ball Turnip", "Seven Top Turnip"] },
    { label: "Greens", sub: "salads & cooking greens", count: 7, c: "#5E8C6A", t: "#EBF1EA",
      blurb: "Fast, forgiving and cut-and-come-again — the first thing you harvest in spring and the last to quit in fall.",
      items: ["Grand Rapids Lettuce", "Black Seeded Simpson Lettuce", "Butterhead Lettuce", "Ruby Red Leaf Lettuce", "Utah Tall Celery", "Bloomsdale Spinach", "Fordhook Giant Swiss Chard"] },
    { label: "Roots", sub: "store-all-winter crops", count: 5, c: "#B84F22", t: "#F6E7DF",
      blurb: "Plant once, eat for months. These keep in a cool cellar or fridge drawer long after the garden sleeps.",
      items: ["Detroit Dark Red Beet", "Scarlet Nantes Carrot", "Chantenay Red Cored Carrot", "Harris Early Model Parsnip", "Cherry Belle Radish"] },
    { label: "Alliums & Cucurbits", sub: "onions, cukes & squash", count: 4, c: "#A87C2B", t: "#F5ECD6",
      blurb: "Flavor builders and summer abundance — from everyday kitchen onions to vining squash that stores till spring.",
      items: ["Tokyo Long White Bunching Onion", "Marketmore 76 Cucumber", "Black Beauty Squash", "Waltham Butternut Squash"] },
    { label: "Fruiting", sub: "summer staples", count: 2, c: "#C0392B", t: "#F7E4E1",
      blurb: "The crops that make a garden feel like summer — sun-ripe peppers and sweet, prolific cherry tomatoes.",
      items: ["California Wonder Pepper", "Large Red Cherry Tomato"] },
    { label: "Legumes", sub: "soil-building nitrogen-fixers", count: 2, c: "#6B7A33", t: "#EFF1E0",
      blurb: "They feed you and your soil at once — fixing nitrogen underground while filling baskets with beans and peas.",
      items: ["Kentucky Wonder Pole Bean", "Sugar Daddy Pea"] }
  ];

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  /* -------------------------------------------------- *
   * Email capture → durable Shopify customer + Omnisend *
   * One entry point for every signup surface (newsletter*
   * band + zone gates). Creates a marketing-consented   *
   * Shopify customer so Omnisend's Shopify sync promotes *
   * it to a SUBSCRIBED contact, and fires the Omnisend   *
   * web-SDK identify for instant on-site automations.    *
   * Best-effort + non-blocking — UX never waits on it.   *
   * Usage: window.ttSubscribe(email, ["tag", ...])       *
   * -------------------------------------------------- */
  var TT_EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  function ttSubscribe(email, tags) {
    email = String(email || "").trim();
    if (!TT_EMAIL_RE.test(email)) return Promise.resolve(false);
    tags = (tags || []).filter(Boolean);

    // Instant on-site signal for Omnisend (documented web-SDK call).
    try {
      window.omnisend = window.omnisend || [];
      window.omnisend.push(["identifyContact", { email: email }]);
    } catch (e) { /* snippet not ready — Shopify customer sync still captures */ }

    // Durable, verifiable capture: native Shopify customer signup with
    // email-marketing consent + tags. Omnisend syncs it as a subscriber.
    var body = new URLSearchParams();
    body.append("form_type", "customer");
    body.append("utf8", "✓");
    body.append("contact[email]", email);
    if (tags.length) body.append("contact[tags]", tags.join(","));

    return fetch("/contact", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
      body: body.toString()
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  window.ttSubscribe = ttSubscribe;

  /* -------------------------------------------------- *
   * Real add-to-cart for the 33-Pack ([data-tt-buy])   *
   * window.TT is injected by snippets/tt-tokens.liquid *
   * -------------------------------------------------- */
  function ttBuy(btn) {
    var TT = window.TT || {};
    var fallback = TT.productUrl || "/products/33-pack-heirloom-vegetable-seed-bank";
    if (!TT.variantId) { window.location.href = fallback; return; }
    var original = btn ? btn.innerHTML : null;
    if (btn) { btn.setAttribute("aria-busy", "true"); btn.style.opacity = ".75"; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: TT.variantId, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () { window.location.href = TT.cartUrl || "/cart"; })
      .catch(function () {
        if (btn && original !== null) { btn.innerHTML = original; btn.removeAttribute("aria-busy"); btn.style.opacity = ""; }
        window.location.href = fallback;
      });
  }

  function bindCartTriggers() {
    document.querySelectorAll("[data-tt-buy]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); ttBuy(b); });
    });
    // Defensive: any [data-tt-add] with an explicit destination just navigates.
    document.querySelectorAll("[data-tt-add][data-href]").forEach(function (b) {
      b.addEventListener("click", function () { window.location.href = b.getAttribute("data-href"); });
    });
  }

  /* -------------------------------------------------- *
   * Sticky add-to-cart bar (always visible)            *
   * -------------------------------------------------- */
  function bindSticky() {
    var bar = document.querySelector("[data-tt-sticky]");
    if (!bar) return;
    // Persistent: show the bar from load and keep it pinned at every scroll
    // position so the shopper can add to cart at any point on the page.
    bar.classList.add("is-visible");
    // Reserve space at the foot of the page so the fixed bar never permanently
    // covers the footer / last bit of content.
    function pad() { document.body.style.paddingBottom = bar.offsetHeight + "px"; }
    pad();
    window.addEventListener("resize", pad, { passive: true });
  }

  /* -------------------------------------------------- *
   * USDA zone checker                                  *
   * -------------------------------------------------- */
  // Approximate USDA hardiness zone by 3-digit ZIP prefix.
  function zipToZone(zip) {
    if (!/^\d{5}$/.test(zip)) return null;
    var p = parseInt(zip.slice(0, 3), 10);
    var R = [
      [6, 9, 13], [10, 27, 6], [28, 29, 6], [30, 38, 5], [39, 49, 4], [50, 59, 4], [60, 69, 6], [70, 89, 7],
      [100, 119, 7], [120, 129, 5], [130, 149, 5], [150, 196, 6], [197, 199, 7],
      [200, 219, 7], [220, 246, 7], [247, 268, 6], [270, 289, 7], [290, 299, 8],
      [300, 319, 8], [320, 329, 9], [330, 349, 10], [350, 369, 8], [370, 385, 7], [386, 397, 8], [398, 399, 8],
      [400, 427, 6], [430, 459, 6], [460, 479, 6], [480, 499, 5],
      [500, 528, 5], [530, 549, 4], [550, 567, 4], [570, 577, 4], [580, 588, 3], [590, 599, 4],
      [600, 629, 6], [630, 658, 6], [660, 679, 6], [680, 693, 5],
      [700, 714, 9], [716, 729, 7], [730, 741, 7], [750, 769, 8], [770, 789, 9], [790, 799, 8],
      [800, 816, 5], [820, 831, 4], [832, 839, 6], [840, 847, 6], [850, 853, 9], [855, 865, 7], [870, 884, 7], [889, 891, 9], [893, 898, 7],
      [900, 921, 10], [922, 935, 9], [936, 949, 9], [950, 961, 9], [967, 968, 12], [970, 979, 8], [980, 986, 8], [988, 994, 7], [995, 999, 4]
    ];
    for (var i = 0; i < R.length; i++) {
      if (p >= R[i][0] && p <= R[i][1]) return R[i][2];
    }
    return null;
  }

  function computeZone(z) {
    var i = z - 1, yes = [], maybe = [];
    VARIETIES.forEach(function (v) {
      var s = v[1][i];
      if (s === "y") yes.push(v[0]);
      else if (s === "m") maybe.push(v[0]);
    });
    return { yes: yes, maybe: maybe };
  }

  function bindZoneChecker(root) {
    var zip = root.querySelector("[data-tt-zip]");
    var zipForm = root.querySelector("[data-tt-zip-form]");
    var zoneSel = root.querySelector("[data-tt-zone-select]");
    var errEl = root.querySelector("[data-tt-zip-error]");
    var result = root.querySelector("[data-tt-zone-result]");
    if (!result) return;

    var state = { zone: null, unlocked: false, fromZip: "" };

    function setError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || "";
      errEl.style.display = msg ? "block" : "none";
    }

    function render() {
      if (!state.zone) { result.style.display = "none"; return; }
      var z = state.zone;
      var data = computeZone(z);
      var thrive = data.yes.length, effort = data.maybe.length;
      var fromZipNote = state.fromZip
        ? '<p style="font-size:.76rem;color:#9a9484;margin-top:.25rem">Estimated from ZIP ' + esc(state.fromZip) + ".</p>" : "";
      var unlockBlock;
      if (!state.unlocked) {
        unlockBlock =
          '<form data-tt-unlock style="display:flex;gap:.5rem;flex-wrap:wrap;margin-top:.85rem">' +
            '<input type="email" placeholder="Email me the full list + planting calendar" required style="flex:1 1 180px;min-width:0;padding:.65rem .85rem;border:1px solid #DCCFA8;border-radius:10px;font-size:.88rem;font-family:Inter,sans-serif;background:#fff">' +
            '<button type="submit" style="font-weight:600;font-size:.86rem;padding:.65rem 1.1rem;border-radius:10px;border:none;cursor:pointer;background:#1E4D32;color:#F6F1E4;white-space:nowrap">Unlock list</button>' +
          "</form>";
      } else {
        var liStyle = 'style="padding:.22rem 0;font-size:.84rem;color:#3f3b32;border-bottom:1px solid rgba(220,207,168,.5)"';
        var yesLis = data.yes.map(function (v) { return "<li " + liStyle + ">" + esc(v) + "</li>"; }).join("");
        var maybeLis = data.maybe.map(function (v) { return "<li " + liStyle + ">" + esc(v) + "</li>"; }).join("");
        unlockBlock =
          '<div data-ttzcols style="margin-top:.85rem;display:grid;grid-template-columns:1fr 1fr;gap:18px">' +
            '<div><h4 style="font-size:.72rem;text-transform:uppercase;letter-spacing:.14em;color:#1E4D32;border-bottom:1px solid #DCCFA8;padding-bottom:.4rem;margin-bottom:.5rem">Thrives</h4><ul style="list-style:none">' + yesLis + "</ul></div>" +
            '<div><h4 style="font-size:.72rem;text-transform:uppercase;letter-spacing:.14em;color:#D26430;border-bottom:1px solid #DCCFA8;padding-bottom:.4rem;margin-bottom:.5rem">With effort</h4><ul style="list-style:none">' + maybeLis + "</ul></div>" +
          "</div>";
      }
      result.innerHTML =
        '<div style="display:flex;align-items:baseline;gap:.6rem">' +
          '<span style="font-family:\'Playfair Display\',serif;font-size:2.6rem;color:#1E4D32;line-height:.85">' + thrive + "</span>" +
          '<span style="font-family:\'EB Garamond\',serif;font-size:1.1rem;color:#201E19;line-height:1.2">of 33 varieties <span style="color:#D26430;font-style:italic">thrive</span> in Zone ' + z + "</span>" +
        "</div>" +
        '<p style="font-size:.84rem;color:#6a6452;margin-top:.5rem">+' + effort + " more grow with a little season-extending effort.</p>" +
        fromZipNote +
        unlockBlock;
      result.style.display = "block";

      var unlockForm = result.querySelector("[data-tt-unlock]");
      if (unlockForm) {
        unlockForm.addEventListener("submit", function (e) {
          e.preventDefault();
          var emailInput = unlockForm.querySelector('input[type="email"]');
          var email = emailInput ? String(emailInput.value || "").trim() : "";
          if (!TT_EMAIL_RE.test(email)) { if (emailInput) emailInput.focus(); return; }
          ttSubscribe(email, ["zone-selector", "seed-bank-interest", "zone-" + (state.zone || "unknown")]);
          state.unlocked = true;
          render();
        });
      }
    }

    function applyZone(z, fromZip) {
      state.zone = z; state.unlocked = false; state.fromZip = fromZip || "";
      setError("");
      render();
    }

    if (zipForm) {
      zipForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var raw = (zip && zip.value || "").trim();
        var z = zipToZone(raw);
        if (!z) { setError("Enter a valid 5-digit U.S. ZIP code."); return; }
        applyZone(z, raw);
      });
    }
    if (zoneSel) {
      zoneSel.addEventListener("change", function (e) {
        var z = +e.target.value;
        if (!z) { state.zone = null; state.fromZip = ""; render(); return; }
        applyZone(z, "");
      });
    }
  }

  /* -------------------------------------------------- *
   * "What's inside" — tabbed / masonry crop browser    *
   * -------------------------------------------------- */
  function buildWhatsInside(root) {
    var layout = root.getAttribute("data-layout") || "Tabbed";
    var accent = root.getAttribute("data-accent") || "Color-coded";

    var fams = FAMILIES.map(function (f, i) {
      var c = accent === "Emerald only" ? "#1E4D32" : f.c;
      var t = accent === "Emerald only" ? "#E7EEE9" : f.t;
      return Object.assign({}, f, { c: c, t: t, idx: i });
    });

    if (layout === "Masonry") {
      var cards = fams.map(function (f) {
        var chips = f.items.map(function (it) {
          return '<span style="display:inline-flex;align-items:center;gap:.45em;font-size:.86rem;color:#2b2820;background:#FBF7EC;border:1px solid #E4D9BC;border-radius:999px;padding:.42rem .85rem;line-height:1.2"><span style="width:6px;height:6px;border-radius:50%;background:' + f.c + ';flex:none"></span>' + esc(it) + "</span>";
        }).join("");
        return '<div style="break-inside:avoid;background:#fff;border:1px solid #E4D9BC;border-radius:16px;overflow:hidden;box-shadow:0 16px 38px -30px rgba(19,48,34,.55);margin-bottom:18px">' +
          '<div style="display:flex;align-items:center;gap:.75rem;padding:15px 20px;background:' + f.t + '">' +
            '<span style="width:34px;height:34px;border-radius:9px;background:' + f.c + ';color:#fff;display:grid;place-items:center;font-family:\'Playfair Display\',serif;font-size:1.05rem;flex:none">' + f.count + "</span>" +
            '<div><div style="font-size:.82rem;text-transform:uppercase;letter-spacing:.13em;color:#2b2820;font-weight:700">' + esc(f.label) + '</div><div style="font-size:.76rem;color:#8a8472">' + esc(f.sub) + "</div></div>" +
          "</div>" +
          '<div style="display:flex;flex-wrap:wrap;gap:8px;padding:18px 20px">' + chips + "</div>" +
        "</div>";
      }).join("");
      root.innerHTML = '<div data-ttmasonry style="columns:3 320px;column-gap:18px;margin-top:22px">' + cards + "</div>";
      return;
    }

    // Tabbed (default)
    var active = -1; // -1 = "All 33"

    function railButton(opts) {
      return '<button type="button" data-fam="' + opts.idx + '" style="display:flex;align-items:center;gap:.8rem;text-align:left;cursor:pointer;font-family:Inter,sans-serif;padding:13px 15px;border-radius:13px;border:1px solid ' + opts.border + ";background:" + opts.bg + ";color:" + opts.fg + ';transition:all .18s ease">' +
        '<span style="width:38px;height:38px;border-radius:10px;background:' + opts.badgeBg + ";color:" + opts.badgeFg + ';display:grid;place-items:center;font-family:\'Playfair Display\',serif;font-size:1.1rem;flex:none">' + opts.badge + "</span>" +
        '<span style="min-width:0"><span style="display:block;font-size:.92rem;font-weight:700;letter-spacing:.01em">' + opts.label + '</span><span style="display:block;font-size:.76rem;color:' + opts.subColor + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + opts.sub + "</span></span>" +
      "</button>";
    }

    function renderRail() {
      var isAll = active < 0;
      var html = railButton({
        idx: -1, badge: "33", label: "All 33 varieties", sub: "the complete seed bank",
        bg: isAll ? "#1E4D32" : "#fff", fg: isAll ? "#fff" : "#2b2820",
        subColor: isAll ? "rgba(246,241,228,.75)" : "#8a8472",
        badgeBg: isAll ? "rgba(246,241,228,.18)" : "#EFE7CF", badgeFg: isAll ? "#E7C97E" : "#B07A2E",
        border: isAll ? "#1E4D32" : "#E4D9BC"
      });
      html += fams.map(function (f) {
        var on = f.idx === active;
        return railButton({
          idx: f.idx, badge: f.count, label: esc(f.label), sub: esc(f.sub),
          bg: on ? f.c : "#fff", fg: on ? "#fff" : "#2b2820",
          subColor: on ? "rgba(255,255,255,.78)" : "#8a8472",
          badgeBg: on ? "rgba(255,255,255,.2)" : f.t, badgeFg: on ? "#fff" : f.c,
          border: on ? f.c : "#E4D9BC"
        });
      }).join("");
      return html;
    }

    function renderPanel() {
      if (active < 0) {
        var cols = fams.map(function (f) {
          var lis = f.items.map(function (it) {
            return '<li style="font-size:.86rem;color:#4a463d;padding:.16rem 0 .16rem .9rem;position:relative"><span style="position:absolute;left:0;top:.62rem;width:4px;height:4px;border-radius:50%;background:' + f.c + '"></span>' + esc(it) + "</li>";
          }).join("");
          return '<div style="break-inside:avoid;margin-bottom:20px">' +
            '<div style="display:flex;align-items:center;gap:.55rem;margin-bottom:.55rem"><span style="width:11px;height:11px;border-radius:3px;background:' + f.c + ';flex:none"></span><span style="font-size:.74rem;text-transform:uppercase;letter-spacing:.13em;font-weight:700;color:#2b2820">' + esc(f.label) + '</span><span style="font-size:.72rem;color:#b0a98f">' + f.count + "</span></div>" +
            '<ul style="list-style:none">' + lis + "</ul>" +
          "</div>";
        }).join("");
        return '<div style="padding:clamp(22px,3vw,30px);display:flex;flex-direction:column;flex:1">' +
          '<div style="display:flex;align-items:baseline;justify-content:space-between;flex-wrap:wrap;gap:.5rem;border-bottom:1px solid #EFE7CF;padding-bottom:14px;margin-bottom:18px">' +
            '<h3 style="font-family:\'Playfair Display\',serif;font-weight:400;font-size:1.7rem;color:#1E4D32">The complete seed bank</h3>' +
            '<span style="font-size:.84rem;color:#8a8472">33 varieties · 6 crop families · 30,000+ seeds</span>' +
          "</div>" +
          '<div style="columns:3 220px;column-gap:26px;flex:1">' + cols + "</div>" +
        "</div>";
      }
      var f = fams[active];
      var chips = f.items.map(function (it) {
        return '<span style="display:inline-flex;align-items:center;gap:.5em;font-size:.92rem;color:#2b2820;background:#FBF7EC;border:1px solid #E4D9BC;border-radius:999px;padding:.5rem 1rem;line-height:1.2"><span style="width:7px;height:7px;border-radius:50%;background:' + f.c + ';flex:none"></span>' + esc(it) + "</span>";
      }).join("");
      return '<div style="padding:clamp(24px,3.2vw,34px);background:' + f.t + ';border-bottom:1px solid rgba(0,0,0,.05)">' +
          '<div style="display:flex;align-items:center;gap:.9rem"><span style="width:46px;height:46px;border-radius:12px;background:' + f.c + ';color:#fff;display:grid;place-items:center;font-family:\'Playfair Display\',serif;font-size:1.4rem;flex:none">' + f.count + '</span><div><h3 style="font-family:\'Playfair Display\',serif;font-weight:400;font-size:1.7rem;color:#201E19;line-height:1">' + esc(f.label) + '</h3><div style="font-size:.82rem;color:#6a6452;margin-top:2px">' + esc(f.sub) + "</div></div></div>" +
          '<p style="font-family:\'EB Garamond\',serif;font-size:1.18rem;color:#3f3b32;line-height:1.5;margin-top:14px;max-width:60ch">' + esc(f.blurb) + "</p>" +
        "</div>" +
        '<div style="padding:clamp(22px,3vw,30px);flex:1;display:flex;flex-direction:column">' +
          '<div style="display:flex;flex-wrap:wrap;gap:9px;align-content:flex-start;flex:1">' + chips + "</div>" +
          '<div style="display:flex;align-items:center;gap:.5em;margin-top:20px;padding-top:16px;border-top:1px solid #EFE7CF;font-size:.86rem;color:#6a6452"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3F7A52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Open-pollinated &amp; non-GMO — save your seed and replant free, forever.</div>' +
        "</div>";
    }

    function paint() {
      root.innerHTML =
        '<div data-tttabs style="display:grid;grid-template-columns:290px 1fr;gap:18px;align-items:stretch;margin-top:22px">' +
          '<div data-ttrail style="display:flex;flex-direction:column;gap:9px">' + renderRail() + "</div>" +
          '<div data-ttpanel style="background:#fff;border:1px solid #E4D9BC;border-radius:18px;box-shadow:0 18px 44px -30px rgba(19,48,34,.55);overflow:hidden;display:flex;flex-direction:column;min-height:440px">' + renderPanel() + "</div>" +
        "</div>";
      root.querySelectorAll("[data-fam]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          active = parseInt(btn.getAttribute("data-fam"), 10);
          paint();
        });
      });
    }
    paint();
  }

  /* -------------------------------------------------- *
   * Newsletter band → real capture via ttSubscribe      *
   * -------------------------------------------------- */
  function bindNewsletter() {
    document.querySelectorAll("[data-tt-newsletter]").forEach(function (form) {
      if (form.dataset.ttBound) return;
      form.dataset.ttBound = "1";
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var email = input ? String(input.value || "").trim() : "";
        if (!TT_EMAIL_RE.test(email)) { if (input) input.focus(); return; }
        ttSubscribe(email, ["newsletter", "homepage"]);
        var btn = form.querySelector("[data-tt-nl-btn]");
        if (btn) btn.textContent = "You're in ✓";
        if (input) { input.value = ""; input.disabled = true; }
      });
    });
  }

  /* -------------------------------------------------- *
   * Init                                               *
   * -------------------------------------------------- */
  function init() {
    bindCartTriggers();
    bindSticky();
    bindNewsletter();
    document.querySelectorAll("[data-tt-zone]").forEach(bindZoneChecker);
    document.querySelectorAll("[data-tt-whats-inside]").forEach(buildWhatsInside);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
